import { render } from "./UserProfile.vue?vue&type=template&id=31e5912d&scoped=true&bindings={\"dayjs\":\"setup-maybe-ref\",\"fetch\":\"setup-maybe-ref\",\"data\":\"setup-maybe-ref\",\"notFound\":\"setup-maybe-ref\",\"page\":\"setup-maybe-ref\",\"userId\":\"setup-maybe-ref\"}"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=31e5912d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31e5912d"

export default script